import script from "./HandlerPlayAudio.vue?vue&type=script&setup=true&lang=js"
export * from "./HandlerPlayAudio.vue?vue&type=script&setup=true&lang=js"

import "./HandlerPlayAudio.vue?vue&type=style&index=0&id=1fa56062&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa56062"]])

export default __exports__